import { Action, Reducer } from "redux";
import { ControlState, ControlTypes, ControlActionTypes } from "./controlTypes";

export const INITIAL_STATE: ControlState = {
	controlsByScreen: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: true,
	},
};

const controlReducer: Reducer<ControlState> = (state: ControlState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as ControlActionTypes;
	switch (actionTypes.type) {
		case ControlTypes.GET_CONTROLS_BY_SCREEN:
			return {
				...state,
				controlsByScreen: { ...state.controlsByScreen, isLoading: true },
			};
		case ControlTypes.SAVE_CONTROLS_BY_SCREEN:
			return {
				...state,
				controlsByScreen: {
					...state.controlsByScreen,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ControlTypes.RESET_REDUCER_CONTROLS_BY_SCREEN:
			return {
				...state,
				controlsByScreen: INITIAL_STATE.controlsByScreen,
			};
		default:
			return state;
	}
};

export default controlReducer;
